import { shiftServiceApi } from "../../app/shiftServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import {
  GetShiftCalenderEmployeeParams,
  GetShiftCalenderEmployeeResponseType,
  GetShiftCalenderParams,
  GetShiftCalenderResponseType,
  GetShiftCartDataParams,
  GetShiftCartDataResponseType,
} from "../../types/shiftAssignEmployee";

export const shiftAssignToEmployeeApi = shiftServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getShiftCalender: builder.query<
      GetShiftCalenderResponseType,
      GetQueryArgsType<GetShiftCalenderParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getShiftCalender,
        ...queryArgs,
      }),
      providesTags: ["GetShiftCalender"],
    }),
    assignToShift: builder.mutation({
      query: (data) => ({
        url: API_URL.assignToShift,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetShiftCalender", "GetShiftCartData"];
        return [];
      },
    }),
    assignGeneralAttendance: builder.mutation({
      query: (data) => ({
        url: API_URL.assignGeneralAttendance,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetShiftCalender", "GetShiftCartData"];
        return [];
      },
    }),
    unAssigned: builder.mutation({
      query: (data) => ({
        url: API_URL.unAssigned,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetShiftCalender", "GetShiftCartData"];
        return [];
      },
    }),
    getShiftCartData: builder.query<
      GetShiftCartDataResponseType,
      GetQueryArgsType<GetShiftCartDataParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getShiftCartData,
        ...queryArgs,
      }),
      providesTags: ["GetShiftCartData"],
    }),
    updatePreviousWeekendStatus: builder.mutation({
      query: () => ({
        url: API_URL.updatePreviousWeekendStatus,
        method: "PATCH",
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetShiftCalender", "GetShiftCartData"];
        return [];
      },
    }),
    updatePreviousAllGeneral: builder.mutation({
      query: (data) => {
        return {
          url: API_URL.updatePreviousAllGeneral,
          method: "PATCH",
          body: data,
        };
      },
      invalidatesTags: (result) => {
        if (result) return ["GetShiftCalender", "GetShiftCartData"];
        return [];
      },
    }),
    shiftCalenderEmployee: builder.query<
      GetShiftCalenderEmployeeResponseType,
      GetQueryArgsType<GetShiftCalenderEmployeeParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.shiftCalenderEmployee,
        ...queryArgs,
      }),
    }),
  }),
});

export const {
  useGetShiftCalenderQuery,
  useAssignToShiftMutation,
  useAssignGeneralAttendanceMutation,
  useUnAssignedMutation,
  useGetShiftCartDataQuery,
  useUpdatePreviousWeekendStatusMutation,
  useUpdatePreviousAllGeneralMutation,
  useLazyGetShiftCalenderQuery,
  useShiftCalenderEmployeeQuery,
} = shiftAssignToEmployeeApi;
